<template>
    <!--<Header/>-->
    <HeaderDisabled/>
    <teleport to="#messages">
        <FlashMessage/>
    </teleport>
    <main class="flex-grow mt-14">
        <router-view></router-view>
    </main>
    <Footer/>
    <Cookie/>
</template>

<script>

import {useStore} from "vuex";
import {API} from "@/utils/api";
import FlashMessage from "./components/page/FlashMessage";
import Footer from "./components/page/Footer";

export default {
    components: {Footer},
    props: {
        initialData: Object
    },
    setup() {

        const store = useStore();
        console.log('setup user')
        API.get('user').then((response) => {
            console.log('setup user',response)
            store.dispatch('Customer/setUser', response.data)

        }).catch((error) => {
            store.dispatch('Customer/logout')
        })

    }
};
</script>
